import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 0 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h2 {
    margin: 0;
  }
`;

export const CategoryProductsMenu = styled.div`
  display: flex;
  h2 {
    font-weight: bold;
  }
`;

export const SecondaryProductsMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    justify-content: center;
    align-items: center;

    button {
      margin-right: 8px;
    }
  }
`;
